import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import { routes } from '../../routes/AppRoutes';
import { strings } from '../../resources/strings';
import { useAuth } from '../../contexts/AuthContext';
import { Body } from '../../common-components/Layout/Body/Body';
import { Header } from '../../common-components/Layout/Header/Header';
import { Page } from '../../common-components/Layout/Page/Page';
import { IBreadcrumbItem } from '../../common-components/Breadcrumb/Breadcrumb';
import { Button } from '../../common-components/Button/Button';
import { If } from '../../common-components/If/If';
import { ModalAmaroNewOrderImport } from '../../components/ModalAmaroNewOrderImport/ModalAmaroNewOrderImport';

const ManageAmaroIntegrations: React.FC = () => {

  const navigate = useNavigate();
  const { session, signOut } = useAuth();

  const [modalNewOrderImportVisible, setModalNewOrderImportVisible] = React.useState<boolean>(false);

  const breadcrumbItems: IBreadcrumbItem[] = React.useMemo(() => {
    const memo: IBreadcrumbItem[] = [
      {
        text: strings.Home,
        route: routes.Home
      }
    ];
    return memo;
  }, []);

  useEffect(() => {
    if (!session) {
      signOut(() => {
        navigate(routes.Login);
      });
      return;
    }
  }, [session, navigate]);

  const headerRender = (
    <Header title={strings.ManageAmaroIntegrations} breadcrumbItems={breadcrumbItems} alertSummary={false} />
  );

  return (
    <Page header={headerRender}>
      <Body marginTop='5px'>

        <Card>
          <Card.Body>
            <Card.Title>Importação de Pedidos</Card.Title>
            <Card.Text>
              Importa pedidos para Shopify, Sislog e Omie.
            </Card.Text>
            <Button colorIcon='primary' text='Nova Importação' click={() => setModalNewOrderImportVisible(true)} marginRight='10px' />
            <Button colorIcon='primary' text='Listar Importações' click={() => navigateToListAmaroOrderImports()} />
          </Card.Body>
        </Card>

      </Body>

      <If condition={modalNewOrderImportVisible}>
        <ModalAmaroNewOrderImport
          close={() => setModalNewOrderImportVisible(false)}
        />
      </If>
    </Page>
  );

  function navigateToListAmaroOrderImports() {
    navigate(routes.ListAmaroOrderImports);
  }
}

export default ManageAmaroIntegrations;